import { openSubcontractorDrawer } from '../../../State/subcontractorDrawer'

export default () => (dispatch, getState) => {

  const { controls: { periodIndex } } = getState().screens.Planner

  dispatch(openSubcontractorDrawer({ periodIndex }))

}
